import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationEventHttpResponse, NotificationEvent } from '@app/models/notification-settings';
import { map, Observable } from 'rxjs';

const HttpServiceMethods = {
  NotificationEvent: 'NotificationEvent'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationEventsService {

  constructor(private httpService: HttpCallService) { }

  public list(): Observable<NotificationEvent[]> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationEvent)
      .pipe(
        map((res) => res.map((item: INotificationEventHttpResponse) => NotificationEvent.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationEvent> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationEvent + `/${id}`)
      .pipe(map((item: INotificationEventHttpResponse) => NotificationEvent.adapt(item)));
  }

  public add(event: NotificationEvent) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationEvent,
      event
    );
  }

  public update(event: NotificationEvent) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationEvent,
      event
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.NotificationEvent + `/${id}`
    );
  }
}
